import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService, CookieUtil, Platform, CommonPlatformService, SelectUserDTO, CommonUserService, CommonUtil } from 'psd-common';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'central-login-sso-login',
    templateUrl: 'central-login-sso-login.component.html'
})
export class CentralLoginSsoLoginComponent implements OnInit {
    public centralAccessToken: string;
    public centralRefreshToken: string;
    public platformPrefix: string;
    public platform: Platform;
    public origin: string;
    public joinToken: string;
    public email: string;
    public errorMessage: string;
    public accessToken: string;
    public refreshToken: string;
    public expiresIn: string;

    constructor(@Inject(DOCUMENT) private document: Document,
                private renderer: Renderer2,
                private authenticationService: AuthenticationService,
                private platformService: CommonPlatformService,
                private route: ActivatedRoute,
                private userService: CommonUserService,
                private router: Router) {}

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'login');

        this.route.queryParams.subscribe(_params => {
            this.centralAccessToken = _params.token;
            this.centralRefreshToken = _params.refresh_token;
            this.platformPrefix = _params.platform;
            this.origin = _params.origin;
            this.joinToken = _params.joinToken;
            this.email = _params.email;

            if (this.platformPrefix) {
                this.platformService.getExternalPlatformDetails(this.platformPrefix).subscribe(_result => {
                    this.platform = _result;

                    if (this.origin == 'join') {
                        this.processJoin();
                    } else {
                        this.processLogin();
                    }
                });
            } else {
                if (this.origin == 'join') {
                    this.processJoin();
                } else {
                    this.processLogin();
                }
            }
        });
    }

    processJoin() {
        let platformURL = CommonUtil.getBaseURL(this.platform.name, 'api', environment.production, this.platform.domainExtension);
        this.userService.joinPlatform(this.joinToken, this.email, platformURL, this.centralAccessToken).subscribe(
          _result => {
                let selectUserDTO: SelectUserDTO = new SelectUserDTO();
                selectUserDTO.platformId = this.platform.id;
                selectUserDTO.userId = _result.id;

                this.authenticationService.selectUser(selectUserDTO, this.centralAccessToken, platformURL).subscribe(
                _selectUserResult => {
                    this.accessToken = _selectUserResult.access_token;
                    this.refreshToken = _selectUserResult.refresh_token;
                    this.expiresIn = _selectUserResult.expires_in;
                    platformURL = CommonUtil.getBaseURL(this.platform.name, 'platform', environment.production, this.platform.domainExtension);
                    this.goToPlatform(platformURL);
                },
                _selectUserError => {
                    this.errorMessage = 'central-login.sso.join.error';
                    /*localStorage.removeItem('userEmail');
                    this.cookieService.delete('central_access_token');
                    this.cookieService.delete('central_refresh_token');*/
                }
                );
        },
          _error => {
              this.errorMessage = 'central-login.sso.join.error';
          });
    }

    processLogin() {
        CookieUtil.setCentralCookies(this.centralAccessToken, this.centralRefreshToken, environment.production);
        this.authenticationService.loadCurrentPossibleUsers(this.centralAccessToken, this.platform?.name).subscribe(_users => {
            if(_users && _users.length > 0 && this.platform) {
                // if platform prefix available and only one user
                if(_users.length == 1) {
                    let selectUserDTO = new SelectUserDTO();
                    selectUserDTO.userId = _users[0].platformUserId;
                    selectUserDTO.platformId = _users[0].platformId;
                    this.authenticationService.selectUser(selectUserDTO, this.centralAccessToken, _users[0].apiURL).subscribe(_selectUserResult => {
                        this.accessToken = _selectUserResult.access_token;
                        this.refreshToken = _selectUserResult.refresh_token;
                        this.expiresIn = _selectUserResult.expires_in;
                        let platformUrl = _users[0].platformURL + '/index.php';
                        this.goToPlatform(platformUrl);
                    });
                } else {
                    // multiple users for this account, platform available => go to select-account page
                    this.router.navigate(['/central-login/select-account'], { queryParams: { platform: this.platformPrefix }});
                }
            } else if(!this.platform) {
                this.router.navigate(['/central-login/dashboard']);
            } else if(_users && _users.length == 0 && this.platform) {
                this.router.navigate(['/central-login/select-account'], { queryParams: { platform: this.platformPrefix, error: 'no-user' }})
            }
        });
    }

    goToPlatform(url: string) {
        // @ts-ignore
        let platformForm: HTMLFormElement = document.getElementById('goToPlatformForm');
        platformForm.action = url;
        platformForm['central_access_token'].value = this.centralAccessToken;
        platformForm['central_refresh_token'].value = this.centralRefreshToken;
        platformForm['access_token'].value = this.accessToken;
        platformForm['refresh_token'].value = this.refreshToken;
        platformForm['expires_in'].value = this.expiresIn;
        platformForm['force_token_refresh'].value = 'true';
        platformForm.submit();
    }
}
